import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography } from 'antd';
import { connect, useSelector } from 'react-redux';

import { StyledFormType } from '../CSS/style';
import translation from '../../../commons/translation';
import { constant } from '../Utils/constants';
import AMMRouter from '../../../routes/ammRoute';
import goback from '../Utils/images/goback_1.png';

const AMM = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const translationCache = useSelector((state) => state.TranslationReducer.translationCache);
  const pathname = location.pathname;

  const renderFormName = (param) => {
    const pathMatches = {
      '/rubus/AMM/ItemDetails/': constant.ITEM_MASTER,
      '/rubus/AMM/MaterialDetails/': constant.MATERIAL_MASTER,
      '/rubus/AMM/ToolsDetails/': constant.TOOL_MASTER,
      '/rubus/AMM/TasksDetails/': constant.TASK_MASTER,
      '/rubus/AMM/JobPlanDetails/': constant.JOBPLAN,
      '/rubus/AMM/WorkOrderDetails/': constant.WORKORDERS,
      '/rubus/AMM/PreventiveMaintenanceDetails/': constant.PREVENTIVEMAINTENANCE,
      '/rubus/AMM/CMDetails/': constant.CONDITIONAL_MONITORING,
      '/rubus/AMM/EWODetails/': constant.TARGET_REPORTING,
      '/rubus/AMM/FieldDataMeasurementDetails/': constant.FIELD_DATA_MEASUREMENT,
      '/rubus/AMM/ManPowerDetails/': constant.MANPOWER_MASTER,
      '/rubus/AMM/InspectionDetails/': constant.INSPECTION,
      '/rubus/AMM/FailureCodeDetails/': constant.FAILURE_MASTER,
      '/rubus/AMM/EquipmentDetails/': constant.EQUIPMENT_MASTER,
      '/rubus/AMM/WorkFlowDetails/': constant.WORK_FLOW,
      '/rubus/AMM/SRDetails/': constant.SERVICE_REQUEST,
      '/rubus/AMM/InspectionMasterDetails/': constant.INSPECTION,
      '/rubus/AMM/InventoryDetails/': constant.INVENTORY,
      '/rubus/AMM/EquipmentOverviewDetails/': constant.EQUIPMENT_OVERVIEW,
      '/rubus/AMM/ELogScheduleDetails/': constant.ELOG_SCHEDULE,
      '/rubus/AMM/Location/': constant.LOCATION
    };

    const basePath = param.split('/').slice(0, 4).join('/') + '/';
    return pathMatches[basePath]
      ? translation(translationCache, pathMatches[basePath])
      : '-';

  };


  return (
    <div>
      {pathname.includes('Details') ? (
        <div>
          <div style={{ position: 'relative', height: '40px' }}>
            <span
              style={{
                position: 'absolute',
                left: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer'
              }}
              onClick={() => navigate(-1)}
            >
              <img src={goback} alt="logo" style={{ width: '25px' }} />
            </span>

            <StyledFormType>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {renderFormName(pathname)}
              </Typography.Title>
            </StyledFormType>
          </div>


          <AMMRouter />
        </div>
      ) : (
        <AMMRouter />
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(AMM);
